import Vue from 'vue'
import Router from 'vue-router'
import Resource from 'vue-resource'
import Isotope from 'vueisotope'
import Node from '@/components/Node'
import Work from '@/components/Work'
import scrollTo from 'vue-scrollto'
import VueTouch from 'vue-touch'

Vue.use(Router)
Vue.use(Resource)
Vue.use(Isotope)
Vue.use(scrollTo)
Vue.use(VueTouch, {name: 'v-touch'})

export default new Router({
  mode: 'hash',
  routes: [
    {
      path: '/:path(projects|projects/.*)?',
      name: 'Projects',
      component: Work
    },
    {
      path: '/:title([a-zA-Z][a-zA-Z0-9_-]+)',
      name: 'Node',
      component: Node
    }
  ]
})



// WEBPACK FOOTER //
// ./src/router/index.js